// @mui
import {
  Box,
  Stack,
  Typography,
  Dialog,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// hooks
import useResponsive from '../../hooks/useResponsive';
// utils
import SvgIconStyle from '../../components/SvgIconStyle';
import Iconify from '../../components/Iconify';

export default function ConfirmNegoPlanDialog({ isOpen, closeDialog, confirm, confirmData, isSubmitting, workType }) {
  const smUp = useResponsive('up', 'sm');
  const { salary, workingHours, trialSalary, trialWorkingHours, longtermSalary, longtermWorkingHours } = confirmData;
  const isResidentWork = workType === "resident";

  return (
    <Dialog open={isOpen} onClose={closeDialog} fullWidth maxWidth="md">
      <DialogContent sx={{ pb: "0!important" }}>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
          <Iconify icon={"eva:alert-triangle-fill"} sx={{ width: 20, height: 20, color: 'error.main' }} />
          <Typography variant="subtitle2" sx={{ color: "error.main" }}>
            잠깐, 꼭 확인해주세요
          </Typography>
        </Stack>
        {isResidentWork ? (
          <Typography variant={smUp ? "h5" : "subtitle1"} gutterBottom>
            두 가지 계약 플랜을 확인하고 제안해주세요.
          </Typography>
        ) : (
          <Typography variant={smUp ? "h5" : "subtitle1"} gutterBottom>
            세 가지 계약 플랜을 확인하고 제안해주세요.
          </Typography>
        )}
        <Typography variant={smUp ? "body1" : "body2" } sx={{ wordBreak: "keep-all" }} paragraph>
          회사가 {isResidentWork ? "두" : "세"} 가지 플랜 중 하나를 선택하여 계약하게 됩니다.  <br />
          내가 제안한 계약 조건과 {isResidentWork ? "장기" : "체험판, 장기"} 플랜을 모두 확인하고 제안해 주세요.
        </Typography>

        <Stack sx={{ width: 1}} direction={{ xs: "column", md: "row" }} alignItems="flex-start" spacing={2}>
          {/* 4주 플랜 */}
          <Box
            sx={{
              width: 1,
              p: 3,
              borderRadius: 2,
              border: "1px solid rgba(145, 158, 171, 0.24)",
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography variant={smUp ? "h5" : "subtitle1"}>
                4주 정식 계약
              </Typography>
              <Typography variant="subtitle2" sx={{ color: "text.disabled" }}>
                플랜
              </Typography>
            </Stack>
            <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
              내가 설정한 4주 인건비와 주당 업무 시간이에요.
            </Typography>
            <Stack spacing={.5} sx={{ mb: 2 }}>
              <Stack direction="row" spacing={1} alignItems="center">
                <SvgIconStyle src={`/icons/icon-coin-mono.svg`} sx={{ color: "text.disabled" }} />
                <Typography variant="h6">
                  인건비
                </Typography>
              </Stack>
              <Stack direction="row" sx={{ pl: 4 }} spacing={1}>
                <Typography sx={{ color: "secondary.main" }} variant="subtitle1">
                  {salary}만원
                </Typography>
              </Stack>
            </Stack>
            <Stack spacing={.5}>
              <Stack direction="row" spacing={1} alignItems="center">
                <SvgIconStyle src={`/icons/ic_clock.svg`} sx={{ color: "text.disabled" }} />
                <Typography variant="h6">
                  주당 업무 가능한 시간
                </Typography>
              </Stack>
              <Stack direction="row" sx={{ pl: 4 }} spacing={1}>
                <Typography sx={{ color: "secondary.main" }} variant="subtitle1">
                  주 {workingHours}시간
                </Typography>
              </Stack>
            </Stack>
          </Box>
          {/* 2주 플랜 */}
          {!isResidentWork && (
          <Box
            sx={{
              width: 1,
              p: 3,
              borderRadius: 2,
              border: "1px solid rgba(145, 158, 171, 0.24)",
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography variant={smUp ? "h5" : "subtitle1"}>
                2주 체험판 계약
              </Typography>
              <Typography variant="subtitle2" sx={{ color: "text.disabled" }}>
                플랜
              </Typography>
            </Stack>
            <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
              짧게 일해보고 계약하고 싶은 기업이 선택하는 플랜이에요.
            </Typography>
            <Stack spacing={.5} sx={{ mb: 2 }}>
              <Stack direction="row" spacing={1} alignItems="center">
                <SvgIconStyle src={`/icons/icon-coin-mono.svg`} sx={{ color: "text.disabled" }} />
                <Typography variant="h6">
                  인건비
                </Typography>
              </Stack>
              <Stack direction="row" sx={{ pl: 4 }} spacing={1}>
                <Typography sx={{ color: "secondary.main" }} variant="subtitle1">
                  {trialSalary}만원
                </Typography>
              </Stack>
            </Stack>
            <Stack spacing={.5}>
              <Stack direction="row" spacing={1} alignItems="center">
                <SvgIconStyle src={`/icons/ic_clock.svg`} sx={{ color: "text.disabled" }} />
                <Typography variant="h6">
                  주당 업무 가능한 시간
                </Typography>
              </Stack>
              <Stack direction="row" sx={{ pl: 4 }} spacing={1}>
                <Typography sx={{ color: "secondary.main" }} variant="subtitle1">
                  주 {trialWorkingHours}시간
                </Typography>
              </Stack>
            </Stack>
          </Box>
          )}
          {/* 8주 플랜 */}
          <Box
            sx={{
              width: 1,
              p: 3,
              borderRadius: 2,
              border: "1px solid rgba(145, 158, 171, 0.24)",
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography variant={smUp ? "h5" : "subtitle1"}>
                8주 장기 계약 계약
              </Typography>
              <Typography variant="subtitle2" sx={{ color: "text.disabled" }}>
                플랜
              </Typography>
            </Stack>
            <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
              이탈 없이 길게 계약을 원하는 기업이 선택하는 플랜이에요.
            </Typography>
            <Stack spacing={.5} sx={{ mb: 2 }}>
              <Stack direction="row" spacing={1} alignItems="center">
                <SvgIconStyle src={`/icons/icon-coin-mono.svg`} sx={{ color: "text.disabled" }} />
                <Typography variant="h6">
                  인건비
                </Typography>
              </Stack>
              <Stack direction="row" sx={{ pl: 4 }} spacing={1}>
                <Typography sx={{ color: "secondary.main" }} variant="subtitle1">
                  {longtermSalary}만원
                </Typography>
              </Stack>
            </Stack>
            <Stack spacing={.5}>
              <Stack direction="row" spacing={1} alignItems="center">
                <SvgIconStyle src={`/icons/ic_clock.svg`} sx={{ color: "text.disabled" }} />
                <Typography variant="h6">
                  주당 업무 가능한 시간
                </Typography>
              </Stack>
              <Stack direction="row" sx={{ pl: 4 }} spacing={1}>
                <Typography sx={{ color: "secondary.main" }} variant="subtitle1">
                  주 {longtermWorkingHours}시간
                </Typography>
              </Stack>
            </Stack>
          </Box>
        </Stack>

        <Typography variant="body2" sx={{ color: "text.secondary", mt: 2 }}>
          최종 지급액은 위 인건비 금액에서 수수료와 세금이 차감된 금액으로 지급됩니다.
        </Typography>

      </DialogContent>
      <DialogActions>
        <Stack sx={{ width: 1 }} direction={{ xs: "column-reverse", sm: "row" }} justifyContent="flex-end" spacing={1}>
          <LoadingButton
            variant="text"
            onClick={closeDialog}
            size="large"
            sx={{ px: 2 }}
            fullWidth={!smUp}
            loading={isSubmitting}
          >
            계약 조건 수정하기
          </LoadingButton>
          <LoadingButton
            variant="contained"
            onClick={confirm}
            size="large"
            sx={{ px: 6 }}
            fullWidth={!smUp}
            loading={isSubmitting}
          >
            제안하기
          </LoadingButton>
        </Stack>
      </DialogActions>
    </Dialog>
  )
};
